import React from 'react';
import { observer } from 'mobx-react';
import { withErrorBoundary } from 'react-error-boundary';
import ComponentError from 'components/Error/ComponentError';
import { handleError } from 'services/ErrorService';

import './styles.scss';

type Props = {
  url: string;
  title?: string;
  aspectRatio?: string;
};

const ArcadeDemo = ({ url, title, aspectRatio = '11/5' }: Props) => (
  <iframe
    src={url}
    style={{
      width: '100%',
      aspectRatio,
      border: 0,
      margin: 0,
      padding: 0,
      display: 'block',
    }}
    allowFullScreen
    allow="fullscreen"
    loading="lazy"
    title={title || 'Arcade Demo'}
  />
);

export default withErrorBoundary(
  observer(ArcadeDemo),
  ComponentError,
  handleError,
);
